import classes from './P2PAdminPanel.module.css';
import P2PListItem from './P2PListItem';

const SidebarList: React.FC<{}> = () => {
    const list = ['waiting', 'permits', 'rejected'];

    return (
        <ul style={{ display: 'block', padding: '12px' }} className={classes['list']}>
            {list.map((item, key) => (
                <P2PListItem index={key + 1} title={item} key={key + 1} />
            ))}
        </ul>
    );
};

export default SidebarList;
